import { render, staticRenderFns } from "./document-part-container.vue?vue&type=template&id=26d62fbe&scoped=true&"
import script from "./document-part-container.vue?vue&type=script&lang=js&"
export * from "./document-part-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d62fbe",
  null
  
)

export default component.exports